import { DatePicker } from "@king-ict/eupisi-ui/components";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ValidationFailure } from "../../../models";

interface IProps {
  dateFrom?: Date | null;
  dateTo?: Date | null;
  onDateFromChange: (date: Date) => void;
  onDateToChange: (date: Date) => void;
  plaintext?: boolean;
  errors: ValidationFailure[] | undefined;
  disabled?: boolean;
  colMd?: number;
}

// How many years in the past and future we allow to select
const DATE_RANGE = {
  min: 4,
  max: 5,
};

export const CommitteeDateRangePicker = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  plaintext = false,
  errors,
  disabled = false,
  colMd = 3,
}: IProps) => {
  const { t } = useTranslation();
  const now = new Date();

  const handleDateFromChange = (e: any) => {
    const newDate = new Date(e.target.value);
    onDateFromChange(newDate);
  };

  const handleDateToChange = (e: any) => {
    const newDate = new Date(e.target.value);
    onDateToChange(newDate);
  };

  return (
    <>
      <Col md={colMd}>
        <DatePicker
          label={t("common.expertCommission.dateFrom")}
          name="expertCommission.dateFrom"
          onChange={handleDateFromChange}
          disabled={disabled}
          value={dateFrom}
          minYear={now.getFullYear() - DATE_RANGE.min}
          maxYear={now.getFullYear() + DATE_RANGE.max}
          plaintext={plaintext}
          errorText={
            errors?.find((e) => e.propertyName === "DateFrom")?.message
          }
        />
      </Col>
      <Col md={colMd}>
        <DatePicker
          label={t("common.expertCommission.dateTo")}
          name="expertCommission.dateTo"
          onChange={handleDateToChange}
          disabled={disabled}
          value={dateTo}
          minYear={now.getFullYear() - DATE_RANGE.min}
          maxYear={now.getFullYear() + DATE_RANGE.max}
          plaintext={plaintext}
          errorText={errors?.find((e) => e.propertyName === "DateTo")?.message}
        />
      </Col>
    </>
  );
};
